<template>
  <div :class="view_class_view.div_container">
    <div>
        
      <!-- Forms -->
      <div >
        <div >
          <UploadFile 
            ref="uploadFileComponent"
            :documentsAllowed="documentsAllowed"
            :maxSizeBytesToUpload="maxSizeBytesForDocuments"
            :maxSizeMegaBytesToUpload="maxSizeMegaBytesForDocuments"
            :maxFiles="maxFiles"
            :minFiles="minFiles"
            v-on:upload-file="getUploadFileResponse($event)"
            v-on:deleted-file="getDeletedFileResponse($event)" />
        </div>
      </div>
      <div >
          <tags
            :disableInput="true"
            :confirmDelete="true"
            :tags="documentTags" 
            v-on:deleted-file="getDeletedTag($event)"
            style="margin-top:30px;">
          </tags>
      </div>
    </div>

    <div class="grid grid-cols-2 gap-2">
        <!-- Tipo de documento -->
        <div class="mt-10">
          <label class="label-input w-full block tracking-wide mb-3" for="select_document_type">Tipo de documento:</label>
          <select
              v-model.trim="identificationRegisterModelValidation.document_type.$model"
              name="select_document_type"
              id="select_document_type"
              :class="{
                'invalid-form': identificationRegisterModelValidation.document_type.$error,
                'valid-form': !identificationRegisterModelValidation.document_type.$invalid,
              }"
              class="outline-none shadow-md border-2 rounded-lg py-2 w-full px-3 focus:border-cherryColor"
            >
              <option v-for="(document_type, index) in documents_type_list" :value="document_type" :key="index" :id="'document_type_'+document_type"> {{document_type}} </option>
          </select>

          <div :class="view_class_view.div_container_error.container"  v-for="error of identificationRegisterModelValidation.document_type.$errors" :key="error.$message">
            <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
          </div>
        </div>

        <!-- Número de Identificación INE/IFE -->
        <div class="mt-10" v-if="identificationRegisterModelValidation.document_type.$model == 'INE/IFE'">
          <label class="label-input w-full block tracking-wide mb-3" for="input_identification_number">
            Número de Identificación:
          </label>
          <input
            id="input_identification_number"
            name="input_identification_number"
            type="text"
            v-maska="'#############'"
            v-model.trim="identificationRegisterModelValidation.identification_number.$model"
            v-bind:class="{[ view_class_view.classInputs.default + view_class_view.classInputs.no_valid ]: identificationRegisterModelValidation.identification_number.$error,
              [view_class_view.classInputs.default + view_class_view.classInputs.valid]:!identificationRegisterModelValidation.identification_number.$invalid,
              [view_class_view.classInputs.default ]: identificationRegisterModelValidation.identification_number.$invalid && !identificationRegisterModelValidation.identification_number.$error  }"
            class="outline-none shadow-md border-2 rounded-lg py-2 w-full px-3 focus:border-cherryColor"
          />

          <div :class="view_class_view.div_container_error.container" v-for="error of identificationRegisterModelValidation.identification_number.$errors" :key="error.$message">
            <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
          </div>

        </div>

        <!-- Numero de pasaporte -->
        <div class="mt-10" v-if="identificationRegisterModelValidation.document_type.$model == 'Pasaporte'">
          <label class="label-input w-full block tracking-wide mb-3" for="input_passport_number">
            Número de Pasaporte:
          </label>
          <input
            id="input_passport_number"
            name="input_passport_number"
            type="text"
            v-maska="'XXXXXXXXXX'"
            v-model.trim="identificationRegisterModelValidation.passport_number.$model"
            v-bind:class="{[ view_class_view.classInputs.default + view_class_view.classInputs.no_valid ]: identificationRegisterModelValidation.passport_number.$error,
              [view_class_view.classInputs.default + view_class_view.classInputs.valid]:!identificationRegisterModelValidation.passport_number.$invalid,
              [view_class_view.classInputs.default ]: identificationRegisterModelValidation.passport_number.$invalid && !identificationRegisterModelValidation.passport_number.$error  }"
            class="outline-none shadow-md border-2 rounded-lg py-2 w-full px-3 focus:border-cherryColor"
          />

          <div :class="view_class_view.div_container_error.container" v-for="error of identificationRegisterModelValidation.passport_number.$errors" :key="error.$message">
            <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
          </div>

        </div>
      </div>
    </div>
</template>

<script>
import { ref, computed, watch } from 'vue';
import UploadFile from './Forms/UploadFile/UploadFile';
import Tags from './Forms/Inputs/Tags/Tag';
import useVuelidate from "@vuelidate/core";

export default {
    name: 'IdentificationRegisterComponent',
    props: {
      validations: {
        type: Object,
        default(){
          return {};
        }
      },
      view_class_view: {
        type: Object,
        default(){
          return {};
        }
      }
    },
    setup(props, {emit}){
      let uploadFileComponent = ref(null);
      let documents_type_list = [
          "INE/IFE",
          "Pasaporte"
      ];
      let identification_number = ref("");
      let passport_number = ref("");
      let document_type = ref("");
      let documentTags = ref([]);
      let documentsAllowed = ref([".pdf", ".png", ".PNG", ".jpeg"]);
      let maxSizeBytesForDocuments = ref(2621440);
      let maxSizeMegaBytesForDocuments = ref(2.5);
      let maxFiles = ref(2);
      let minFiles = ref(1);
      let files = ref([]);

      let identificationRegister = ref({
        identification_number:"",
        passport_number: "",
        document_type: ""
      });

      let identificationDocuments = computed(()=> {
        return {
          document_type: identificationRegister.value.document_type,
          identification_number: identificationRegister.value.identification_number,
          passport_number: identificationRegister.value.passport_number,
        };
      });

      watch(identificationDocuments, (value) => {
        emit('identification-register-data', {
          files: files.value,
          identification_number: value.identification_number,
          passport_number: value.passport_number.toString().toUpperCase(),
          document_type: value.document_type
        });
      });

      let identificationRegisterModelValidation = useVuelidate(props.validations, identificationRegister);

      function execute_validation(){
        identificationRegisterModelValidation.value.$validate();
        if(identificationRegisterModelValidation.value.$error){
          return false;
        }

        return {
          files: files.value,
          identification_number: identificationRegisterModelValidation.value.identification_number.$model,
          passport_number: identificationRegisterModelValidation.value.passport_number.$model.toString().toUpperCase(),
          document_type: identificationRegisterModelValidation.value.document_type.$model
        };
      }

      function getUploadFileResponse(event) {
        addTag(event.newFile.name);

        files.value = event;
        emit('identification-register-data', {
          files: event,
          identification_number: identificationRegisterModelValidation.value.identification_number.$model,
          passport_number: identificationRegisterModelValidation.value.passport_number.$model.toString().toUpperCase(),
          document_type: identificationRegisterModelValidation.value.document_type.$model
        });
      }

      function getDeletedFileResponse(event) {

        files.value = event;
        emit('identification-register-data', {
          files: event,
          identification_number: identificationRegisterModelValidation.value.identification_number.$model,
          passport_number: identificationRegisterModelValidation.value.passport_number.$model.toString().toUpperCase(),
          document_type: identificationRegisterModelValidation.value.document_type.$model
        });
      }

      function addTag(tag) {
        documentTags.value.push({value: tag, text: tag});
      }

      function getDeletedTag(event) {
        uploadFileComponent.value.deleteFile(event.deletedTag.value);
      }

      return { 
        getUploadFileResponse,
        getDeletedFileResponse,
        getDeletedTag,
        identificationRegisterModelValidation,
        execute_validation,
        documents_type_list,
        identification_number,
        passport_number,
        document_type,
        documentTags,
        documentsAllowed,
        maxSizeBytesForDocuments,
        maxSizeMegaBytesForDocuments,
        maxFiles,
        minFiles,
        files,
        uploadFileComponent,
        identificationDocuments
      }
    },

    components: {
      UploadFile,
      Tags
    }
  }
  </script>